import { TokyoCoords } from "common/consts/googleMaps";
import { PlaceResult } from "common/interfaces/PlaceResult";
import { useCallback, useState } from "react";

const initialValues = {
  map: undefined as google.maps.Map | undefined,
  location: null as google.maps.LatLngLiteral | null,
  center: {
    lat: TokyoCoords.lat,
    lng: TokyoCoords.lng
  } as google.maps.LatLngLiteral,
  zoom: 19,
  placeResult: undefined as PlaceResult | undefined
};

export const useMapHooks = () => {
  const [map, setMap] = useState<google.maps.Map | undefined>(
    initialValues.map
  );
  const [location, setLocation] = useState<google.maps.LatLngLiteral | null>(
    initialValues.location
  );
  const [center, setCenter] = useState<google.maps.LatLngLiteral>(
    initialValues.center
  );
  const [zoom, setZoom] = useState<number>(initialValues.zoom);
  const [placeResult, setPlaceResult] = useState<PlaceResult | undefined>(
    initialValues.placeResult
  );

  const initialize = useCallback(() => {
    setMap(initialValues.map);
    setLocation(initialValues.location);
    setCenter(initialValues.center);
    setZoom(initialValues.zoom);
    setPlaceResult(initialValues.placeResult);
  }, []);

  return {
    map,
    setMap,
    location,
    setLocation,
    center,
    setCenter,
    zoom,
    setZoom,
    placeResult,
    setPlaceResult,

    initialize
  } as const;
};
